import tw, { styled } from 'twin.macro';

import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import { Link } from 'gatsby';

import { Heading, Input, TextArea, Error } from '../atoms';

const Button = styled.button(() => [tw`bg-white py-2`]);

const ContactUsForm = (props) => {
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
    errors,
    touched,
  } = props;
  return (
    <div tw="w-full bg-green rounded py-10 px-5">
      <form onSubmit={handleSubmit} tw="w-full max-w-lg mx-auto">
        <Heading tw="text-2xl mt-0 text-white font-normal">
          Get in touch
        </Heading>
        <div tw="py-8">
          <div tw="flex flex-wrap -mx-3 mb-5">
            <div tw="w-full px-3 mb-6 md:mb-0">
              <Input
                name="name"
                type="text"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Name"
              />
              <Error>
                {errors.name && touched.name ? errors.name : undefined}
              </Error>
            </div>
          </div>
          <div tw="flex flex-wrap -mx-3 mb-5">
            <div tw="w-full px-3">
              <Input
                name="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Email"
              />
              <Error>
                {errors.email && touched.email ? errors.email : undefined}
              </Error>
            </div>
          </div>
          <div tw="flex flex-wrap -mx-3 mb-5">
            <div tw="w-full px-3">
              <TextArea
                placeholder="Message"
                name="message"
                type="text"
                rows="3"
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
          <p tw="text-gray-light">
            By submitting this form, you thereby agree to our contact{' '}
            <Link to="/terms-and-conditions">
              <span tw="text-white font-bold border-b">
                terms and conditions
              </span>
            </Link>
          </p>
        </div>
        <Button
          type="submit"
          variant="secondary"
          disabled={isSubmitting}
          css={[tw`w-full`, isSubmitting ? tw`cursor-wait` : tw``]}
        >
          <span tw="text-green font-semibold">Submit</span>
        </Button>
      </form>
    </div>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    name: '',
    email: '',
    message: '',
  }),
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required!'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required!'),
    message: Yup.string().required('Message is required!'),
  }),

  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    props
      .onSubmit(values)
      .finally(() => {
        setSubmitting(false);
        resetForm();
      })
      .catch(() => {
        setSubmitting(false);
      });
  },
  displayName: 'ContactUsForm', // helps with React DevTools
})(ContactUsForm);
